import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";

const ThemeServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {
    let endpt_elem = [
      {
        page_section: "checkThemeStatus",
        method: "GET",
        endpoint: "/api/public/themesvc/checkThemeStatus",
        sampleRequest:
          "/api/public/themesvc/checkThemeStatus?queryName=kindergartens&dateTime=2023-06-15T16%3A00%3A00.000Z",
        sampleResponse: '{\n  "UpdatedFile": true\n}',
      },
      {
        page_section: "getThemeInfo",
        method: "GET",
        endpoint: "/api/public/themesvc/getThemeInfo",
        sampleRequest:
          "/api/public/themesvc/getThemeInfo?queryName=kindergartens",
        sampleResponse:
          '{\n  "Theme_Names": [\n    {\n      "THEMENAME": "Kindergartens",\n      "QUERYNAME": "kindergartens"\n    }\n  ]\n}',
      },
      {
        page_section: "getAllThemesInfo",
        method: "GET",
        endpoint: "/api/public/themesvc/getAllThemesInfo",
        sampleRequest: "/api/public/themesvc/getAllThemesInfo?moreInfo=Y",
        sampleResponse:
          '{\n  "Theme_Names": [\n    {\n      "THEMENAME": "Kindergartens",\n      "QUERYNAME": "kindergartens",\n      "ICON": "school.gif",\n      "EXPIRY_DATE": "31/12/2026",\n      "PUBLISHED_DATE": "01/01/2012",\n      "CATEGORY": "Education",\n      "THEME_OWNER": "EARLY CHILDHOOD DEVELOPMENT AGENCY"\n    },\n    {\n      "THEMENAME": "Community Clubs",\n      "QUERYNAME": "communityclubs",\n      "ICON": "PA.jpg",\n      "EXPIRY_DATE": "31/12/2022",\n      "PUBLISHED_DATE": "01/01/2012",\n      "CATEGORY": "Community",\n      "THEME_OWNER": "PEOPLE\'S ASSOCIATION"\n    },...,   \n    {\n      "THEMENAME": "CET Centres",\n      "QUERYNAME": "cetcentres",\n      "ICON": "WSQ.jpg",\n      "EXPIRY_DATE": "31/12/2021",\n      "PUBLISHED_DATE": "01/01/2012",\n      "CATEGORY": "Education",\n      "THEME_OWNER": "SINGAPORE WORKFORCE DEVELOPMENT AGENCY"\n    }\n  ]\n}',
      },
      {
        page_section: "retrieveTheme",
        method: "GET",
        endpoint: "/api/public/themesvc/retrieveTheme",
        sampleRequest:
          "/api/public/themesvc/retrieveTheme?queryName=dengue_cluster",
        sampleResponse:
          '{\n  "SrchResults": [\n    {\n      "FeatCount": 40,\n      "Theme_Name": "Dengue Clusters",\n      "Category": "Health",\n      "Owner": "NATIONAL ENVIRONMENT AGENCY",\n      "DateTime": "2023-07-11T15:54:59+00:00",\n      "Published_Date": "2013-06-26T00:00:00+00:00",\n      "Formatted_DateTime": "11/07/2023",\n      "Formatted_Published_Date": "26/06/2013"\n    },\n    {\n      "NAME": "Dengue_Cluster",\n      "DESCRIPTION": "Lor 4 Toa Payoh (Blk 62B, 66, 71, 73) / Lor 5 Toa Payoh (Blk 55)",\n      "HYPERLINK": "https://www.nea.gov.sg/dengue-zika/dengue/dengue-clusters",\n      "CASE_SIZE": "8",\n      "HOMES": "Domestic containers, Pail, Planter box, Flower pot plate/tray",\n      "PUBLIC_PLACES": "Puddle/ground depression, Domestic containers, Canvas sheet, Closed perimeter darain, Plant leaves, Inspection chamber, Discarded coconut husks, Scupper darin, Tree hole, Disacrded receptacles",\n      "MAPTIP": "Dengue_Cluster",\n      "SYMBOLCOLOR": "#FFFFFF",\n      "Type": "Polygon",\n      "LatLng": "[[103.850350730955,1.33866331941482],[103.850675995233,1.33845777044955],[103.850832242221,1.33835903262749],[103.851021145103,1.33820261057472],[103.852125919154,1.337226154554],[103.852820647897,1.33646601266903],[103.853470125116,1.33573928180302],[103.853689562754,1.33540526743064],[103.853794864562,1.33505969802759],[103.853801661111,1.33471673401618],[103.853763046875,1.33454362088808],[103.853615613621,1.33424332336343],[103.853442863977,1.33399475026009],[103.853201249917,1.33375405381435],[103.85145507206,1.33347300987719],[103.851353579675,1.33416235976273],[103.851293165986,1.3343972001566],[103.851259079473,1.3345568740998],[103.851184191992,1.3348179881942],[103.851082557678,1.33502975311817],[103.850955961659,1.33527561456845],[103.850854326799,1.33541559374158],[103.850344668896,1.33612841292271],[103.850223895785,1.33629830315427],[103.849942575137,1.33668264733536],[103.849873899538,1.33686186933158],[103.849846361961,1.3369419690815],[103.849779319569,1.33720230622839],[103.849774566459,1.33737698154924],[103.849806425447,1.3376019040183],[103.849900573891,1.33789717567323],[103.849987114171,1.33804600725171],[103.850165424435,1.33835228443411],[103.850350730955,1.33866331941482]]",\n     "GeoJSON": {\n       "type": "Feature",\n       "properties": {},\n       "geometry": {\n         "type": "Polygon",\n         "coordinates": "[[103.850350730955,1.33866331941482],[103.850675995233,1.33845777044955],[103.850832242221,1.33835903262749],[103.851021145103,1.33820261057472],[103.852125919154,1.337226154554],[103.852820647897,1.33646601266903],[103.853470125116,1.33573928180302],[103.853689562754,1.33540526743064],[103.853794864562,1.33505969802759],[103.853801661111,1.33471673401618],[103.853763046875,1.33454362088808],[103.853615613621,1.33424332336343],[103.853442863977,1.33399475026009],[103.853201249917,1.33375405381435],[103.85145507206,1.33347300987719],[103.851353579675,1.33416235976273],[103.851293165986,1.3343972001566],[103.851259079473,1.3345568740998],[103.851184191992,1.3348179881942],[103.851082557678,1.33502975311817],[103.850955961659,1.33527561456845],[103.850854326799,1.33541559374158],[103.850344668896,1.33612841292271],[103.850223895785,1.33629830315427],[103.849942575137,1.33668264733536],[103.849873899538,1.33686186933158],[103.849846361961,1.3369419690815],[103.849779319569,1.33720230622839],[103.849774566459,1.33737698154924],[103.849806425447,1.3376019040183],[103.849900573891,1.33789717567323],[103.849987114171,1.33804600725171],[103.850165424435,1.33835228443411],[103.850350730955,1.33866331941482]]"\n       }\n     },\n    "ICON_NAME": "mosquitoa20.jpg"\n    },...\n  ]\n}',
      },
      {
        page_section: "retrieveThemeExtent",
        method: "GET",
        endpoint: "/api/public/themesvc/retrieveTheme",
        sampleRequest:
          "/api/public/themesvc/retrieveTheme?queryName=dengue_cluster&extents=1.291789%2C103.7796402%2C1.3290461%2C103.8726032",
        sampleResponse:
          '{\n  "SrchResults": [\n    {\n      "FeatCount": 3,\n      "Theme_Name": "Dengue Clusters",\n      "Category": "Health",\n      "Owner": "NATIONAL ENVIRONMENT AGENCY",\n      "DateTime": "2023-07-11T15:54:59+00:00",\n      "Published_Date": "2013-06-26T00:00:00+00:00",\n      "Formatted_DateTime": "11/07/2023",\n      "Formatted_Published_Date": "26/06/2013"\n    },\n    {\n      "NAME": "Dengue_Cluster",\n      "DESCRIPTION": "Angklong Ln (Faber Gdn Condo) / Island Gdns Walk / Sin Ming Ave (Flame Tree Pk) / Sin Ming Walk (The Gdns at Bishan) / The Inglewood",\n      "HYPERLINK": "https://www.nea.gov.sg/dengue-zika/dengue/dengue-clusters",\n      "CASE_SIZE": "30",\n      "HOMES": "Ornamental containers, Domestic containers",\n      "PUBLIC_PLACES": "Ornamental containers, Plastic tray, Closed perimeter draun, Closed other drains, Keyhole, Open carpark drain",\n      "MAPTIP": "Dengue_Cluster",\n      "SYMBOLCOLOR": "#FFFFFF",\n      "Type": "Polygon",\n      "LatLng": "[[103.89920987978,1.3967446013845]]",\n      "ICON_NAME": "mosquitoa20.jpg"\n    }\n  ]\n}',
      },
    ];
    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;
    

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>

      <Helmet>
        <title>Themes API, Access 100+ Thematic Layers for Location Analysis</title>
        <meta
          name="description"
          content="Leverage the OneMap Themes API to retrieve over 100 thematic layers provided by government agencies. Use these layers for location analysis and application development. Check theme status and access detailed theme info with easy-to-use APIs such as AED, Theatres, Child care, Dementia GTP"
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div className="om-theme-section">
              <h1>Themes</h1>
              <div className="om-theme-intro">
                <p>
                  OneMap has over 100 thematic layers that users can retrieve
                  via API. These thematic layers are provided by various
                  government agencies. Use this API for location analysis or
                  developing applications that bring out the livability of an
                  area.
                </p>
              </div>
              <hr />
              <h1 id="checkThemeStatus">Check Theme Status</h1>
              <p>This API checks if the themes are updated.</p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>
                400 - Please send the access token in the request header as a
                bearer token.
              </p>
              <p>400 - There is no query name.</p>
              <p>400 - Your date provided is empty.</p>
              <p>
                401 - Token has expired: Session expired. Please refresh your
                token (if still within refresh window) or re-login.
              </p>
              <p>
                401 - Invalid token: Could not decode token: The token xxx; is
                an invalid JWS.
              </p>
              <p>
                403 - Access Forbidden. GET access to component 'xxx' of service
                'xxx' is not allowed by this user's role.
              </p>
              <p>429 - API limit(s) exceeded.</p>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      queryName
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Query name. Themes’ query names can be retrieved using
                        Get All Themes Info service.
                      </p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      dateTime
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>
                        The datetime in YYYY-MM-DDTHH:MM:SS:FFFZ. EG:
                        2023-06-15T16:00:00.000Z format.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("checkThemeStatus")} />
              <h1 id="getThemesInfo">Get Theme Info</h1>
              <p>
                This API searches themes with queryName and returns the themes'
                info.
              </p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>
                400 - Please send the access token in the request header as a
                bearer token.
              </p>
              <p>400 - There is no query name</p>
              <p>
                401 - Token has expired: Session expired. Please refresh your
                token (if still within refresh window) or re-login.
              </p>
              <p>
                401 - Invalid token: Could not decode token: The token xxx; is
                an invalid JWS.
              </p>
              <p>
                403 - Access Forbidden. GET access to component 'xxx' of service
                'xxx' is not allowed by this user's role.
              </p>
              <p>429 - API limit(s) exceeded.</p>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      queryName
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Enables users to retrieve theme information. Themes'
                        query names can be retrieved using Get All Themes Info
                        service.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getThemeInfo")} />
              <h1 id="getAllThemesInfo">Get All Themes Info</h1>
              <p>
                This API retrieves and returns a list of all available themes.
              </p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>
                400 - Please send the access token in the request header as a
                bearer token.
              </p>
              <p>
                401 - Token has expired: Session expired. Please refresh your
                token (if still within refresh window) or re-login.
              </p>
              <p>
                401 - Invalid token: Could not decode token: The token xxx; is
                an invalid JWS.
              </p>
              <p>
                403 - Access Forbidden. GET access to component 'xxx' of service
                'xxx' is not allowed by this user's role.
              </p>
              <p>429 - API limit(s) exceeded.</p>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      moreInfo
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Optional. Values: Y, N. Returns more information of
                        themes such as icon names, category names, and theme
                        owners if set as Y. Default is N.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getAllThemesInfo")} />
              <h1 id="retrieveTheme">Retrieve Theme</h1>
              <p>
                This API searches and returns specified list of themes that are
                filtered by the search term.
              </p>
              
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>
                400 - Please send the access token in the request header as a
                bearer token.
              </p>
              <p>400 - There is no query name</p>
              <p>
                401 - Token has expired: Session expired. Please refresh your
                token (if still within refresh window) or re-login.
              </p>
              <p>
                401 - Invalid token: Could not decode token: The token xxx; is
                an invalid JWS.
              </p>
              <p>
                403 - Access Forbidden. GET access to component 'xxx' of service
                'xxx' is not allowed by this user's role.
              </p>
              <p>429 - API limit(s) exceeded.</p>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      queryName
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Enables users to retrieve theme information. Themes'
                        query names can be retrieved using Get All Themes Info
                        service.
                      </p>
                    </div>
                  </div>
                  {/* <div className='om-theme-item'>
                    <div className='label-method'>
                      dateTime
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>The datetime in YYYY-MM-DDTHH:MM:SS:FFFZ. EG: 2015-02-10T16:00:00.000Z format.</p>
                    </div>
                  </div> */}
                </div>
              </div>
              <Endpoint {...endpointreturn("retrieveTheme")} />
              <h1 id="retrieveThemeExtent">Retrieve Theme - With Extents</h1>
              <p>
                This API searches and returns specified list of themes that are
                filtered by the search term within the specified boundary
              </p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>
                400 - Please send the access token in the request header as a
                bearer token.
              </p>
              <p>
                401 - Token has expired: Session expired. Please refresh your
                token (if still within refresh window) or re-login.
              </p>
              <p>
                401 - Invalid token: Could not decode token: The token xxx; is
                an invalid JWS.
              </p>
              <p>
                403 - Access Forbidden. GET access to component 'xxx' of service
                'xxx' is not allowed by this user's role.
              </p>
              <p>429 - API limit(s) exceeded.</p>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      queryName
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                  </div>
                  <div className="om-theme-item">
                    <div className="label-method">
                      extents
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>
                        Optional. Boundary provided by user. EG:
                        1.291789,103.7796402,1.3290461,103.8726032
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("retrieveThemeExtent")} />
            </div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default ThemeServices;
